const adminAppUrls = {
  development: 'http://localhost:4000',
  staging: 'https://staging-admin.goboon.co',
  production: 'https://admin.goboon.co',
  demo: 'https://demo-admin.goboon.co',
};

const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
const adminAppUrl = adminAppUrls[environment];

export default adminAppUrl;
